// /* PALCO Magic Eraser – Auto Free Gift (Shiprocket Smart Cart) v16 */
// (() => {
//   "use strict";

//   if (window.__MAGIC_GIFT_V16__) return;
//   window.__MAGIC_GIFT_V16__ = true;

//   const CFG = {
//     handle: "magic-eraser",
//     threshold: 69900,                    // ₹699 (paise me)
//     marker: "_magic_eraser_auto_gift",
//     hostId: "shiprocket-smart-cart-root",
//     fallbackTitle: "Cherinova Magic Eraser (Pack Of 2)",
//     useDiscountedPrice: false,           // true = discount ke baad wala total check hoga
//     debug: false
//   };

//   const FALLBACK_ID = "magic-gift-inline";

//   // Cart badalne wale buttons (theme + Shiprocket drawer)
//   const CART_CONTROL_SEL = [
//     ".mini-cart-qty-btn",
//     ".mini-cart-item-delete",
//     ".mini-cart-item-actions button",
//     ".sr-upsell-item-action",
//     "#onetick-ATC-button",
//     '[name="plus"]',
//     '[name="minus"]',
//     '[name="add"]',
//     '[class*="add-to-cart" i]',
//     '[class*="cart-icon" i]',
//     '[class*="cart-toggle" i]'
//   ].join(",");

//   // Checkout / Buy now buttons
//   const CHECKOUT_SEL = [
//     'a[href*="/checkout"]',
//     'button[name="checkout"]',
//     'input[name="checkout"]',
//     '[data-testid*="checkout" i]',
//     '[class*="checkout-btn" i]',
//     '[class*="checkout-button" i]',
//     '[id*="checkout-btn" i]',
//     '[class*="buy-now" i]',
//     '[class*="buy_now" i]',
//     ".shopify-payment-button__button"
//   ].join(",");

//   const log = (...a) => CFG.debug && console.log("[MagicGift]", ...a);
//   const delay = ms => new Promise(r => setTimeout(r, ms));
//   const base = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");

//   const nativeFetch = window.fetch.bind(window);
//   const oldOpen = XMLHttpRequest.prototype.open;
//   const oldSend = XMLHttpRequest.prototype.send;

//   let giftId = null;
//   let giftImage = "";
//   let productPromise = null;
//   let cart = null;

//   let pending = 0;          // theme/Shiprocket ki cart writes jo abhi chal rahi hain
//   let lastWriteAt = 0;
//   let version = 0;          // har cart write / cart click par badhta hai
//   let stableVersion = -1;   // kis version par cart last verify hua
//   let running = null;       // chal raha sync (promise)
//   let rerun = false;
//   let timer = null;
//   let lastError = null;
//   let lastSig = "";

//   let shadow = null;
//   let observer = null;
//   let renderQueued = false;
//   let checking = false;
//   let bypass = false;

//   /* ---------------- API ---------------- */

//   async function request(path, opts = {}) {
//     const res = await nativeFetch(base + path, {
//       credentials: "same-origin",
//       cache: "no-store",
//       ...opts
//     });
//     if (!res.ok) {
//       const txt = await res.text().catch(() => "");
//       throw Error(path + " HTTP " + res.status + " " + txt.slice(0, 120));
//     }
//     return res.json();
//   }

//   const post = (path, body) => request(path, {
//     method: "POST",
//     headers: { "Content-Type": "application/json", Accept: "application/json" },
//     body: JSON.stringify(body)
//   });

//   function loadGift() {
//     if (giftId) return Promise.resolve(giftId);
//     if (!productPromise) {
//       productPromise = request("products/" + CFG.handle + ".js")
//         .then(p => {
//           const v = p.variants?.find(x => x.available);
//           if (!v) throw Error("Magic Eraser variant unavailable");
//           giftId = Number(v.id);
//           giftImage = p.featured_image || "";
//           if (giftImage.startsWith("//")) giftImage = "https:" + giftImage;
//           return giftId;
//         })
//         .catch(e => {
//           productPromise = null;
//           throw e;
//         });
//     }
//     return productPromise;
//   }

//   /* ---------------- Rules ---------------- */

//   const isMagic = item =>
//     item.handle === CFG.handle ||
//     item.product_handle === CFG.handle ||
//     (giftId !== null && Number(item.variant_id) === giftId);

//   const isMarked = item =>
//     isMagic(item) && item.properties?.[CFG.marker] === "yes";

//   function paidSubtotal(c) {
//     return c.items.reduce((sum, item) => {
//       if (
//         isMagic(item) ||
//         item.properties?._auto_free_gift ||
//         item.properties?._free_gift ||
//         item.properties?._is_free_gift
//       ) return sum;

//       const price = CFG.useDiscountedPrice
//         ? item.final_line_price ?? item.line_price
//         : item.original_line_price ?? item.line_price;

//       return sum + Math.max(0, Number(price ?? 0));
//     }, 0);
//   }

//   function next(c) {
//     const all = c.items.filter(isMagic);
//     const marked = all.filter(isMarked);

//     // ₹699 se kam: Magic Eraser hatao
//     if (paidSubtotal(c) < CFG.threshold) {
//       return all.length ? { key: all[0].key, qty: 0 } : null;
//     }

//     // ₹699+: sirf ek marked Magic Eraser, qty 1
//     const unmarked = all.find(x => !isMarked(x));
//     if (unmarked) return { key: unmarked.key, qty: 0 };
//     if (marked.length > 1) return { key: marked[1].key, qty: 0 };
//     if (marked.length && marked[0].quantity !== 1) return { key: marked[0].key, qty: 1 };
//     return marked.length ? null : { add: true };
//   }

//   async function change(action) {
//     if (action.add) {
//       await loadGift();
//       await post("cart/add.js", {
//         items: [{ id: giftId, quantity: 1, properties: { [CFG.marker]: "yes" } }]
//       });
//     } else {
//       await post("cart/change.js", { id: action.key, quantity: action.qty });
//     }
//   }

//   /* ---------------- Sync ---------------- */

//   function markDirty() {
//     version++;
//   }

//   async function doSync() {
//     let didChange = false;
//     try {
//       await loadGift();
//       const deadline = Date.now() + 8000;

//       while (Date.now() < deadline) {
//         // Koi request atak gayi ho to 10s baad pending reset
//         if (pending && Date.now() - lastWriteAt > 10000) pending = 0;

//         if (pending) {
//           await delay(60);
//           continue;
//         }

//         const v = version;
//         const data = await request("cart.js");
//         if (pending || v !== version) continue;   // beech me cart badla, dobara padho

//         cart = data;
//         const action = next(data);

//         if (action) {
//           log("action", action);
//           await change(action);
//           didChange = true;
//           continue;                                // change ke baad dobara verify
//         }

//         stableVersion = v;
//         lastError = null;
//         publish(didChange);
//         return;
//       }

//       throw Error("Cart did not settle in time");
//     } catch (e) {
//       lastError = e.message;
//       console.error("[Magic Gift]", e);
//       if (cart) render();
//     }
//   }

//   function sync() {
//     if (running) {
//       rerun = true;
//       return running;
//     }
//     running = doSync().finally(() => {
//       running = null;
//       if (rerun || stableVersion !== version) {
//         rerun = false;
//         queue(lastError ? 1500 : 100);
//       }
//     });
//     return running;
//   }

//   function queue(ms = 0) {
//     clearTimeout(timer);
//     timer = setTimeout(sync, ms);
//   }

//   // Checkout se pehle: fresh cart padh ke pakka karo
//   async function verifyNow(timeout = 6000) {
//     const end = Date.now() + timeout;
//     markDirty();
//     while (Date.now() < end) {
//       if (running) {
//         await running;
//         continue;
//       }
//       if (pending) {
//         await delay(60);
//         continue;
//       }
//       await sync();
//       if (!pending && !running && stableVersion === version && cart && !next(cart)) {
//         return true;
//       }
//     }
//     return false;
//   }

//   /* ---------------- Shiprocket drawer UI ---------------- */

//   const getShadow = () => document.getElementById(CFG.hostId)?.shadowRoot || null;

//   function setText(el, text) {
//     if (el && el.textContent !== text) el.textContent = text;
//   }

//   function setImportant(el, prop, value) {
//     if (
//       el.style.getPropertyValue(prop) !== value ||
//       el.style.getPropertyPriority(prop) !== "important"
//     ) {
//       el.style.setProperty(prop, value, "important");
//     }
//   }

//   // Apne DOM changes ke time observer band – warna infinite loop banta hai
//   function mute(fn) {
//     const obs = observer;
//     obs?.disconnect();
//     try {
//       fn();
//     } finally {
//       if (obs && shadow) obs.observe(shadow, { childList: true, subtree: true });
//     }
//   }

//   function buildCard() {
//     const card = document.createElement("div");
//     card.id = FALLBACK_ID;
//     card.className = "mini-cart-item-wrapper";
//     card.style.cssText = `
//       display:flex;align-items:center;gap:14px;padding:16px;margin:8px 0;
//       border:1px solid #e2e2e2;border-radius:12px;background:#fff;color:#18232f;
//       box-sizing:border-box;font-family:inherit;min-height:120px;width:100%;
//     `;

//     const img = document.createElement("img");
//     img.className = "magic-gift-image";
//     img.alt = "Magic Eraser";
//     img.style.cssText = `
//       width:82px;height:82px;object-fit:contain;flex-shrink:0;
//       border:1px solid #eee;border-radius:10px;
//     `;

//     const details = document.createElement("div");
//     details.style.cssText = `
//       flex:1;min-width:0;display:flex;flex-direction:column;
//       align-items:flex-start;gap:7px;
//     `;

//     const name = document.createElement("strong");
//     name.className = "magic-gift-title";
//     name.style.cssText = `
//       display:block;font-size:16px;font-weight:600;line-height:1.4;
//       color:#18232f;overflow-wrap:anywhere;
//     `;

//     const badge = document.createElement("span");
//     badge.className = "magic-gift-badge";
//     badge.textContent = "🎁 Free Gift";
//     badge.style.cssText = `
//       display:inline-flex;align-items:center;background:#effaf0;
//       border:1px solid #94bc93;color:#427b45;border-radius:20px;
//       padding:4px 12px;font-size:12px;font-weight:600;line-height:1.5;
//       width:max-content;max-width:100%;
//     `;

//     const price = document.createElement("div");
//     price.className = "magic-gift-price";
//     price.style.cssText = `font-size:16px;font-weight:700;line-height:1.2;color:#18232f;`;

//     details.append(name, badge, price);
//     card.append(img, details);
//     return card;
//   }

//   function render() {
//     const root = getShadow();
//     const list = root?.querySelector("#mini-cart-items");
//     if (!list || !cart) return;

//     mute(() => {
//       const gift = cart.items.find(isMarked);
//       const allowed = paidSubtotal(cart) >= CFG.threshold && gift?.quantity === 1;

//       const nativeRows = [...list.querySelectorAll(".mini-cart-item-wrapper")].filter(row => {
//         if (row.id === FALLBACK_ID) return false;
//         if (row.querySelector('a[href*="/products/' + CFG.handle + '"]')) return true;
//         const id = String(row.querySelector(".mini-cart-item-qty[data-id]")?.dataset.id || "");
//         return Boolean(giftId && id.startsWith(giftId + ":"));
//       });

//       nativeRows.forEach(row => {
//         if (!allowed) {
//           setImportant(row, "display", "none");
//         } else {
//           if (row.style.getPropertyValue("display")) row.style.removeProperty("display");
//           const actions = row.querySelector(".mini-cart-item-actions");
//           if (actions) setImportant(actions, "display", "none");
//         }
//       });

//       let card = root.getElementById(FALLBACK_ID);

//       if (!allowed || nativeRows.length) {
//         card?.remove();
//         return;
//       }

//       // Shiprocket ne gift wali row abhi render nahi ki – apna card dikhao
//       if (!card) card = buildCard();
//       if (card.parentNode !== list) list.appendChild(card);

//       setText(card.querySelector(".magic-gift-title"), gift.product_title || CFG.fallbackTitle);

//       const amount = Number(gift.final_line_price ?? 0);
//       setText(
//         card.querySelector(".magic-gift-price"),
//         amount === 0 ? "₹0.00" : "₹" + (amount / 100).toFixed(2)
//       );

//       const img = card.querySelector(".magic-gift-image");
//       const src = gift.featured_image?.url || gift.image || giftImage || "";
//       if (img) {
//         if (src) {
//           if (img.getAttribute("src") !== src) img.setAttribute("src", src);
//           if (img.style.display === "none") img.style.removeProperty("display");
//         } else if (img.style.display !== "none") {
//           img.style.display = "none";
//         }
//       }
//     });
//   }

//   function scheduleRender() {
//     if (renderQueued) return;
//     renderQueued = true;
//     requestAnimationFrame(() => {
//       renderQueued = false;
//       render();
//     });
//   }

//   function publish(didChange) {
//     render();

//     const sig = cart.items.map(i => i.key + ":" + i.quantity).sort().join("|");
//     if (sig === lastSig) return;
//     lastSig = sig;

//     document.dispatchEvent(new CustomEvent("magic-gift:changed", { detail: { cart } }));

//     // Sirf tab jab humne cart badla – taaki theme/Shiprocket refresh ho sake
//     if (didChange) {
//       document.dispatchEvent(
//         new CustomEvent("cart:updated", { detail: { cart, source: "magic-gift-v16" } })
//       );
//       document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart } }));
//     }
//   }

//   function bindDrawer() {
//     const root = getShadow();
//     if (!root || root === shadow) return;

//     observer?.disconnect();
//     shadow = root;
//     observer = new MutationObserver(scheduleRender);
//     observer.observe(root, { childList: true, subtree: true });

//     scheduleRender();
//     queue(0);
//   }

//   function drawerOpen() {
//     const panel = getShadow()?.getElementById("mini-cart-drawer");
//     return Boolean(panel && getComputedStyle(panel).display !== "none");
//   }

//   /* ---------------- Network hooks ---------------- */

//   function isWrite(url, method) {
//     try {
//       return (
//         String(method || "GET").toUpperCase() !== "GET" &&
//         /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(
//           new URL(String(url), location.href).pathname
//         )
//       );
//     } catch {
//       return false;
//     }
//   }

//   function writeStarted() {
//     pending++;
//     lastWriteAt = Date.now();
//     markDirty();
//   }

//   function writeEnded() {
//     pending = Math.max(0, pending - 1);
//     markDirty();
//     queue(0);
//     setTimeout(() => queue(0), 350);
//   }

//   window.fetch = function (input, init) {
//     const url = typeof input === "string" ? input : input?.url || String(input);
//     const method =
//       init?.method || (typeof input === "object" && input?.method) || "GET";

//     if (!isWrite(url, method)) return nativeFetch(input, init);

//     writeStarted();
//     let promise;
//     try {
//       promise = nativeFetch(input, init);
//     } catch (e) {
//       writeEnded();
//       throw e;
//     }
//     return Promise.resolve(promise).finally(writeEnded);
//   };

//   XMLHttpRequest.prototype.open = function (method, url) {
//     this.__magicGiftWrite = isWrite(url, method);
//     return oldOpen.apply(this, arguments);
//   };

//   XMLHttpRequest.prototype.send = function () {
//     if (this.__magicGiftWrite) {
//       writeStarted();
//       this.addEventListener("loadend", writeEnded, { once: true });
//     }
//     return oldSend.apply(this, arguments);
//   };

//   /* ---------------- Notice ---------------- */

//   function showNotice(message, ms = 3500) {
//     let note = document.getElementById("magic-gift-notice");
//     if (!note) {
//       note = document.createElement("div");
//       note.id = "magic-gift-notice";
//       note.setAttribute("role", "status");
//       note.style.cssText = `
//         position:fixed;bottom:20px;left:50%;transform:translateX(-50%);
//         z-index:2147483647;background:#202020;color:#fff;padding:14px 20px;
//         border-radius:8px;font:14px Arial,sans-serif;text-align:center;
//         max-width:90vw;box-shadow:0 5px 25px #0003;
//       `;
//       document.body.appendChild(note);
//     }
//     note.textContent = message;
//     clearTimeout(showNotice.t);
//     showNotice.t = setTimeout(() => note.remove(), ms);
//   }

//   function hideNotice() {
//     clearTimeout(showNotice.t);
//     document.getElementById("magic-gift-notice")?.remove();
//   }

//   /* ---------------- Clicks (document + Shiprocket shadow DOM) ---------------- */

//   function guardCheckout(e, el) {
//     const giftInCart = Boolean(cart?.items.some(isMagic));
//     const clean =
//       !pending && !running && stableVersion === version && cart && !next(cart);

//     // Cart pakka sahi hai aur gift nahi hai – seedha checkout jane do
//     if (clean && !giftInCart) return;

//     e.preventDefault();
//     e.stopImmediatePropagation();

//     if (checking) return;
//     checking = true;
//     showNotice("Checking your cart…", 8000);

//     verifyNow().then(ok => {
//       checking = false;

//       if (!ok) {
//         showNotice("Cart is updating. Please try again.");
//         return;
//       }

//       const hasPaid = cart.items.some(i => !isMagic(i) && i.quantity > 0);
//       if (!hasPaid) {
//         showNotice("Free gift cannot be ordered separately.");
//         return;
//       }

//       hideNotice();
//       bypass = true;
//       try {
//         el.click();          // verify hone ke baad wahi button khud dabao
//       } finally {
//         bypass = false;
//       }
//     });
//   }

//   function onClick(e) {
//     if (bypass) return;

//     const path = (e.composedPath ? e.composedPath() : [e.target]).filter(
//       n => n && n.nodeType === 1 && typeof n.matches === "function"
//     );

//     const checkout = path.find(n => n.matches(CHECKOUT_SEL));
//     if (checkout) {
//       guardCheckout(e, checkout);
//       return;
//     }

//     if (path.some(n => n.matches(CART_CONTROL_SEL))) {
//       markDirty();             // turant checkout lock
//       queue(150);
//       setTimeout(() => queue(0), 600);
//       setTimeout(() => queue(0), 1500);
//     }
//   }

//   /* ---------------- Init ---------------- */

//   function init() {
//     bindDrawer();

//     let hostQueued = false;
//     new MutationObserver(() => {
//       if (hostQueued) return;
//       hostQueued = true;
//       requestAnimationFrame(() => {
//         hostQueued = false;
//         bindDrawer();
//       });
//     }).observe(document.documentElement, { childList: true, subtree: true });

//     document.addEventListener("click", onClick, true);
//     window.addEventListener("pageshow", () => queue(0));
//     document.addEventListener("visibilitychange", () => {
//       if (!document.hidden) queue(0);
//     });

//     // Backup: drawer khula ho to har 1.2s cart check (agar Shiprocket ki request miss ho jaye)
//     setInterval(() => {
//       if (document.hidden || pending || running) return;
//       bindDrawer();
//       if (drawerOpen()) queue(0);
//     }, 1200);

//     queue(0);
//   }

//   window.MagicGiftV16 = {
//     refresh: () => {
//       markDirty();
//       queue(0);
//     },
//     inspect: async () => {
//       await loadGift().catch(() => {});
//       const c = await request("cart.js");
//       return {
//         eligibleSubtotal: paidSubtotal(c) / 100,
//         eligible: paidSubtotal(c) >= CFG.threshold,
//         giftInCart: c.items.some(isMarked),
//         nextAction: next(c),
//         pending,
//         version,
//         stableVersion,
//         lastError,
//         drawerFound: Boolean(getShadow()),
//         items: c.items.map(i => ({
//           title: i.title,
//           qty: i.quantity,
//           original: i.original_line_price / 100,
//           final: i.final_line_price / 100,
//           properties: i.properties
//         }))
//       };
//     }
//   };

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", init, { once: true });
//   } else {
//     init();
//   }
// })();

















/* PALCO Magic Eraser – Auto Free Gift (Shiprocket Smart Cart) v16.2 – ribbon card (::before/::after) */
(() => {
  "use strict";

  if (window.__MAGIC_GIFT_V16__) return;
  window.__MAGIC_GIFT_V16__ = true;

  const CFG = {
    handle: "magic-eraser",
    threshold: 69900,                    // ₹699 (paise me)
    marker: "_magic_eraser_auto_gift",
    hostId: "shiprocket-smart-cart-root",
    fallbackTitle: "Cherinova Magic Eraser (Pack Of 2)",
    useDiscountedPrice: false,           // true = discount ke baad wala total check hoga
    debug: false
  };

  const FALLBACK_ID = "magic-gift-inline";

  // Cart badalne wale buttons (theme + Shiprocket drawer)
  const CART_CONTROL_SEL = [
    ".mini-cart-qty-btn",
    ".mini-cart-item-delete",
    ".mini-cart-item-actions button",
    ".sr-upsell-item-action",
    "#onetick-ATC-button",
    '[name="plus"]',
    '[name="minus"]',
    '[name="add"]',
    '[class*="add-to-cart" i]',
    '[class*="cart-icon" i]',
    '[class*="cart-toggle" i]'
  ].join(",");

  // Checkout / Buy now buttons
  const CHECKOUT_SEL = [
    'a[href*="/checkout"]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[data-testid*="checkout" i]',
    '[class*="checkout-btn" i]',
    '[class*="checkout-button" i]',
    '[id*="checkout-btn" i]',
    '[class*="buy-now" i]',
    '[class*="buy_now" i]',
    ".shopify-payment-button__button"
  ].join(",");

  const log = (...a) => CFG.debug && console.log("[MagicGift]", ...a);
  const delay = ms => new Promise(r => setTimeout(r, ms));
  const base = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");

  const nativeFetch = window.fetch.bind(window);
  const oldOpen = XMLHttpRequest.prototype.open;
  const oldSend = XMLHttpRequest.prototype.send;

  let giftId = null;
  let giftImage = "";
  let giftPrice = 0;         // asli price (kati hui dikhane ke liye)
  let productPromise = null;
  let cart = null;

  let pending = 0;          // theme/Shiprocket ki cart writes jo abhi chal rahi hain
  let lastWriteAt = 0;
  let version = 0;          // har cart write / cart click par badhta hai
  let stableVersion = -1;   // kis version par cart last verify hua
  let running = null;       // chal raha sync (promise)
  let rerun = false;
  let timer = null;
  let lastError = null;
  let lastSig = "";

  let shadow = null;
  let observer = null;
  let renderQueued = false;
  let checking = false;
  let bypass = false;

  /* ---------------- API ---------------- */

  async function request(path, opts = {}) {
    const res = await nativeFetch(base + path, {
      credentials: "same-origin",
      cache: "no-store",
      ...opts
    });
    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw Error(path + " HTTP " + res.status + " " + txt.slice(0, 120));
    }
    return res.json();
  }

  const post = (path, body) => request(path, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body)
  });

  function loadGift() {
    if (giftId) return Promise.resolve(giftId);
    if (!productPromise) {
      productPromise = request("products/" + CFG.handle + ".js")
        .then(p => {
          const v = p.variants?.find(x => x.available);
          if (!v) throw Error("Magic Eraser variant unavailable");
          giftId = Number(v.id);
          giftPrice = Math.max(Number(v.compare_at_price || 0), Number(v.price || 0));
          giftImage = p.featured_image || "";
          if (giftImage.startsWith("//")) giftImage = "https:" + giftImage;
          return giftId;
        })
        .catch(e => {
          productPromise = null;
          throw e;
        });
    }
    return productPromise;
  }

  /* ---------------- Rules ---------------- */

  const isMagic = item =>
    item.handle === CFG.handle ||
    item.product_handle === CFG.handle ||
    (giftId !== null && Number(item.variant_id) === giftId);

  const isMarked = item =>
    isMagic(item) && item.properties?.[CFG.marker] === "yes";

  function paidSubtotal(c) {
    return c.items.reduce((sum, item) => {
      if (
        isMagic(item) ||
        item.properties?._auto_free_gift ||
        item.properties?._free_gift ||
        item.properties?._is_free_gift
      ) return sum;

      const price = CFG.useDiscountedPrice
        ? item.final_line_price ?? item.line_price
        : item.original_line_price ?? item.line_price;

      return sum + Math.max(0, Number(price ?? 0));
    }, 0);
  }

  function next(c) {
    const all = c.items.filter(isMagic);
    const marked = all.filter(isMarked);

    // ₹699 se kam: Magic Eraser hatao
    if (paidSubtotal(c) < CFG.threshold) {
      return all.length ? { key: all[0].key, qty: 0 } : null;
    }

    // ₹699+: sirf ek marked Magic Eraser, qty 1
    const unmarked = all.find(x => !isMarked(x));
    if (unmarked) return { key: unmarked.key, qty: 0 };
    if (marked.length > 1) return { key: marked[1].key, qty: 0 };
    if (marked.length && marked[0].quantity !== 1) return { key: marked[0].key, qty: 1 };
    return marked.length ? null : { add: true };
  }

  async function change(action) {
    if (action.add) {
      await loadGift();
      await post("cart/add.js", {
        items: [{ id: giftId, quantity: 1, properties: { [CFG.marker]: "yes" } }]
      });
    } else {
      await post("cart/change.js", { id: action.key, quantity: action.qty });
    }
  }

  /* ---------------- Sync ---------------- */

  function markDirty() {
    version++;
  }

  async function doSync() {
    let didChange = false;
    try {
      await loadGift();
      const deadline = Date.now() + 8000;

      while (Date.now() < deadline) {
        // Koi request atak gayi ho to 10s baad pending reset
        if (pending && Date.now() - lastWriteAt > 10000) pending = 0;

        if (pending) {
          await delay(60);
          continue;
        }

        const v = version;
        const data = await request("cart.js");
        if (pending || v !== version) continue;   // beech me cart badla, dobara padho

        cart = data;
        const action = next(data);

        if (action) {
          log("action", action);
          await change(action);
          didChange = true;
          continue;                                // change ke baad dobara verify
        }

        stableVersion = v;
        lastError = null;
        publish(didChange);
        return;
      }

      throw Error("Cart did not settle in time");
    } catch (e) {
      lastError = e.message;
      console.error("[Magic Gift]", e);
      if (cart) render();
    }
  }

  function sync() {
    if (running) {
      rerun = true;
      return running;
    }
    running = doSync().finally(() => {
      running = null;
      if (rerun || stableVersion !== version) {
        rerun = false;
        queue(lastError ? 1500 : 100);
      }
    });
    return running;
  }

  function queue(ms = 0) {
    clearTimeout(timer);
    timer = setTimeout(sync, ms);
  }

  // Checkout se pehle: fresh cart padh ke pakka karo
  async function verifyNow(timeout = 6000) {
    const end = Date.now() + timeout;
    markDirty();
    while (Date.now() < end) {
      if (running) {
        await running;
        continue;
      }
      if (pending) {
        await delay(60);
        continue;
      }
      await sync();
      if (!pending && !running && stableVersion === version && cart && !next(cart)) {
        return true;
      }
    }
    return false;
  }

  /* ---------------- Shiprocket drawer UI ---------------- */

  const getShadow = () => document.getElementById(CFG.hostId)?.shadowRoot || null;

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function setImportant(el, prop, value) {
    if (
      el.style.getPropertyValue(prop) !== value ||
      el.style.getPropertyPriority(prop) !== "important"
    ) {
      el.style.setProperty(prop, value, "important");
    }
  }

  // Apne DOM changes ke time observer band – warna infinite loop banta hai
  function mute(fn) {
    const obs = observer;
    obs?.disconnect();
    try {
      fn();
    } finally {
      if (obs && shadow) obs.observe(shadow, { childList: true, subtree: true });
    }
  }

  const BOW_SVG = `
    <svg viewBox="0 0 64 58" width="100%" height="100%" aria-hidden="true">
      <defs>
        <linearGradient id="mgBowGold" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#ffe08a"/>
          <stop offset="1" stop-color="#eba92a"/>
        </linearGradient>
      </defs>
      <path d="M29 26 L19 52 L25 48 L28 55 L34 27Z" fill="url(#mgBowGold)" stroke="#d6951a" stroke-width="1"/>
      <path d="M35 26 L45 52 L39 48 L36 55 L30 27Z" fill="url(#mgBowGold)" stroke="#d6951a" stroke-width="1"/>
      <path d="M32 24 C20 6 3 8 5 21 C7 32 22 30 32 24Z" fill="url(#mgBowGold)" stroke="#d6951a" stroke-width="1.2"/>
      <path d="M32 24 C44 6 61 8 59 21 C57 32 42 30 32 24Z" fill="url(#mgBowGold)" stroke="#d6951a" stroke-width="1.2"/>
      <ellipse cx="32" cy="24" rx="5.5" ry="5" fill="#f4b733" stroke="#d6951a" stroke-width="1.2"/>
    </svg>`;

  // Saara design CSS me – ribbon ::before (aadi patti) aur ::after (khadi patti) se.
  // --mg-i = image size, --mg-f = font size (Shiprocket ki rows se naap kar set hote hain)
  const CARD_CSS = `
    #${FALLBACK_ID}{
      --mg-i:64px;--mg-f:14px;
      position:relative;overflow:hidden;display:flex;align-items:flex-start;
      gap:calc(var(--mg-i) * .22);
      padding:calc(var(--mg-i) * .2) calc(var(--mg-i) * .2);
      min-height:calc(var(--mg-i) * 1.42);
      border:1px solid #d9b44a;border-radius:12px;background:#fff;color:#18232f;
      box-sizing:border-box;width:100%;font-family:inherit;
    }
    #${FALLBACK_ID}::before{
      content:"";position:absolute;left:0;right:0;pointer-events:none;
      bottom:calc(var(--mg-i) * .24);height:calc(var(--mg-i) * .17);
      background:linear-gradient(90deg,#fff5d6,#ffefbd);
    }
    #${FALLBACK_ID}::after{
      content:"";position:absolute;top:0;bottom:0;pointer-events:none;
      right:calc(var(--mg-i) * .34);width:calc(var(--mg-i) * .17);
      background:#ffefbd;
    }
    #${FALLBACK_ID} .mg-bow{
      position:absolute;z-index:1;pointer-events:none;
      width:calc(var(--mg-i) * .5);height:calc(var(--mg-i) * .45);
      right:calc(var(--mg-i) * .175);bottom:calc(var(--mg-i) * .06);
    }
    #${FALLBACK_ID} .mg-img{
      position:relative;z-index:1;flex-shrink:0;
      width:var(--mg-i);height:var(--mg-i);object-fit:contain;
      background:#fff;border:1px solid #e3e3e3;border-radius:10px;
      padding:3px;box-sizing:border-box;
    }
    #${FALLBACK_ID} .mg-details{
      position:relative;z-index:1;flex:1;min-width:0;
      display:flex;flex-direction:column;align-items:flex-start;
      gap:calc(var(--mg-f) * .55);
    }
    #${FALLBACK_ID} .mg-title{
      font-size:var(--mg-f);font-weight:400;line-height:1.35;
      color:#18232f;overflow-wrap:anywhere;
    }
    #${FALLBACK_ID} .mg-badge{
      display:inline-flex;align-items:center;gap:.3em;
      font-size:calc(var(--mg-f) * .9);line-height:1.3;
      padding:.25em .8em;border:1px solid #4f6b3c;border-radius:999px;
      color:#4f6b3c;background:#fff;width:max-content;max-width:100%;
    }
    #${FALLBACK_ID} .mg-price-box{
      position:relative;z-index:1;flex-shrink:0;
      display:flex;flex-direction:column;align-items:flex-end;gap:.35em;
      font-size:var(--mg-f);line-height:1.2;text-align:right;
    }
    #${FALLBACK_ID} .mg-price{color:#18232f}
    #${FALLBACK_ID} .mg-compare{color:#8a8a8a}
  `;

  function ensureStyle(root) {
    if (root.getElementById("magic-gift-style")) return;
    const style = document.createElement("style");
    style.id = "magic-gift-style";
    style.textContent = CARD_CSS;
    root.appendChild(style);
  }

  function buildCard() {
    const card = document.createElement("div");
    card.id = FALLBACK_ID;
    card.innerHTML = `
      <span class="mg-bow">${BOW_SVG}</span>
      <img class="mg-img magic-gift-image" alt="Magic Eraser">
      <div class="mg-details">
        <div class="mg-title magic-gift-title"></div>
        <span class="mg-badge">🎁 Free Gift</span>
      </div>
      <div class="mg-price-box">
        <div class="mg-price magic-gift-price"></div>
        <s class="mg-compare magic-gift-compare"></s>
      </div>`;
    return card;
  }

  // Shiprocket ki koi dikhti hui row dhoondh kar uska image size, font aur gap copy karo
  function measureNative(list) {
    const rows = [...list.querySelectorAll(".mini-cart-item-wrapper")].filter(
      r => r.id !== FALLBACK_ID && r.offsetParent !== null && r.querySelector("img")
    );
    const row = rows[0];
    if (!row) return null;

    const imgW = Math.round(row.querySelector("img").getBoundingClientRect().width);

    let fontPx = 0;
    for (const el of row.querySelectorAll("*")) {
      const t = (el.textContent || "").trim();
      if (el.children.length === 0 && t && !t.includes("₹") && !/^[-+\d\s]+$/.test(t)) {
        fontPx = parseFloat(getComputedStyle(el).fontSize) || 0;
        break;
      }
    }

    const cs = getComputedStyle(row);
    const mt = parseFloat(cs.marginTop) || 0;
    const mb = parseFloat(cs.marginBottom) || 0;

    return {
      img: imgW >= 30 && imgW <= 200 ? imgW : 0,
      font: fontPx >= 10 && fontPx <= 24 ? fontPx : 0,
      top: mt || mb || 12,
      bottom: mb
    };
  }

  function setVar(el, name, value) {
    if (el.style.getPropertyValue(name) !== value) el.style.setProperty(name, value);
  }

  const rupees = paise => {
    const r = paise / 100;
    return "₹" + (Number.isInteger(r) ? r : r.toFixed(2));
  };

  function render() {
    const root = getShadow();
    const list = root?.querySelector("#mini-cart-items");
    if (!list || !cart) return;

    mute(() => {
      const gift = cart.items.find(isMarked);
      const allowed = paidSubtotal(cart) >= CFG.threshold && gift?.quantity === 1;

      // Shiprocket ki apni Magic Eraser row hamesha chhupao – sirf hamara card dikhega
      [...list.querySelectorAll(".mini-cart-item-wrapper")].forEach(row => {
        if (row.id === FALLBACK_ID) return;
        const byLink = row.querySelector('a[href*="/products/' + CFG.handle + '"]');
        const id = String(row.querySelector(".mini-cart-item-qty[data-id]")?.dataset.id || "");
        const byId = giftId && id.startsWith(giftId + ":");
        if (byLink || byId) setImportant(row, "display", "none");
      });

      let card = root.getElementById(FALLBACK_ID);

      if (!allowed) {
        card?.remove();
        return;
      }

      ensureStyle(root);
      if (!card) card = buildCard();

      // Hamesha list me sabse upar
      if (card.parentNode !== list || list.firstElementChild !== card) {
        list.insertBefore(card, list.firstChild);
      }

      // Baaki rows jaisa size
      const m = measureNative(list);
      if (m) {
        if (m.img) setVar(card, "--mg-i", m.img + "px");
        if (m.font) setVar(card, "--mg-f", m.font + "px");
        const margin = m.top + "px 0 " + m.bottom + "px";
        if (card.style.margin !== margin) card.style.margin = margin;
      }

      setText(card.querySelector(".magic-gift-title"), gift.product_title || CFG.fallbackTitle);

      const amount = Number(gift.final_line_price ?? 0);
      setText(card.querySelector(".magic-gift-price"), rupees(amount));

      const original = Math.max(Number(gift.original_line_price || 0), giftPrice);
      const compare = card.querySelector(".magic-gift-compare");
      if (compare) {
        const show = original > amount;
        setText(compare, show ? rupees(original) : "");
        const disp = show ? "" : "none";
        if (compare.style.display !== disp) compare.style.display = disp;
      }

      const img = card.querySelector(".magic-gift-image");
      const src = gift.featured_image?.url || gift.image || giftImage || "";
      if (img) {
        if (src) {
          if (img.getAttribute("src") !== src) img.setAttribute("src", src);
          if (img.style.display === "none") img.style.removeProperty("display");
        } else if (img.style.display !== "none") {
          img.style.display = "none";
        }
      }
    });
  }

  function scheduleRender() {
    if (renderQueued) return;
    renderQueued = true;
    requestAnimationFrame(() => {
      renderQueued = false;
      render();
    });
  }

  function publish(didChange) {
    render();

    const sig = cart.items.map(i => i.key + ":" + i.quantity).sort().join("|");
    if (sig === lastSig) return;
    lastSig = sig;

    document.dispatchEvent(new CustomEvent("magic-gift:changed", { detail: { cart } }));

    // Sirf tab jab humne cart badla – taaki theme/Shiprocket refresh ho sake
    if (didChange) {
      document.dispatchEvent(
        new CustomEvent("cart:updated", { detail: { cart, source: "magic-gift-v16" } })
      );
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart } }));
    }
  }

  function bindDrawer() {
    const root = getShadow();
    if (!root || root === shadow) return;

    observer?.disconnect();
    shadow = root;
    observer = new MutationObserver(scheduleRender);
    observer.observe(root, { childList: true, subtree: true });

    scheduleRender();
    queue(0);
  }

  function drawerOpen() {
    const panel = getShadow()?.getElementById("mini-cart-drawer");
    return Boolean(panel && getComputedStyle(panel).display !== "none");
  }

  /* ---------------- Network hooks ---------------- */

  function isWrite(url, method) {
    try {
      return (
        String(method || "GET").toUpperCase() !== "GET" &&
        /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(
          new URL(String(url), location.href).pathname
        )
      );
    } catch {
      return false;
    }
  }

  function writeStarted() {
    pending++;
    lastWriteAt = Date.now();
    markDirty();
  }

  function writeEnded() {
    pending = Math.max(0, pending - 1);
    markDirty();
    queue(0);
    setTimeout(() => queue(0), 350);
  }

  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input?.url || String(input);
    const method =
      init?.method || (typeof input === "object" && input?.method) || "GET";

    if (!isWrite(url, method)) return nativeFetch(input, init);

    writeStarted();
    let promise;
    try {
      promise = nativeFetch(input, init);
    } catch (e) {
      writeEnded();
      throw e;
    }
    return Promise.resolve(promise).finally(writeEnded);
  };

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__magicGiftWrite = isWrite(url, method);
    return oldOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__magicGiftWrite) {
      writeStarted();
      this.addEventListener("loadend", writeEnded, { once: true });
    }
    return oldSend.apply(this, arguments);
  };

  /* ---------------- Notice ---------------- */

  function showNotice(message, ms = 3500) {
    let note = document.getElementById("magic-gift-notice");
    if (!note) {
      note = document.createElement("div");
      note.id = "magic-gift-notice";
      note.setAttribute("role", "status");
      note.style.cssText = `
        position:fixed;bottom:20px;left:50%;transform:translateX(-50%);
        z-index:2147483647;background:#202020;color:#fff;padding:14px 20px;
        border-radius:8px;font:14px Arial,sans-serif;text-align:center;
        max-width:90vw;box-shadow:0 5px 25px #0003;
      `;
      document.body.appendChild(note);
    }
    note.textContent = message;
    clearTimeout(showNotice.t);
    showNotice.t = setTimeout(() => note.remove(), ms);
  }

  function hideNotice() {
    clearTimeout(showNotice.t);
    document.getElementById("magic-gift-notice")?.remove();
  }

  /* ---------------- Clicks (document + Shiprocket shadow DOM) ---------------- */

  function guardCheckout(e, el) {
    const giftInCart = Boolean(cart?.items.some(isMagic));
    const clean =
      !pending && !running && stableVersion === version && cart && !next(cart);

    // Cart pakka sahi hai aur gift nahi hai – seedha checkout jane do
    if (clean && !giftInCart) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (checking) return;
    checking = true;
    showNotice("Checking your cart…", 8000);

    verifyNow().then(ok => {
      checking = false;

      if (!ok) {
        showNotice("Cart is updating. Please try again.");
        return;
      }

      const hasPaid = cart.items.some(i => !isMagic(i) && i.quantity > 0);
      if (!hasPaid) {
        showNotice("Free gift cannot be ordered separately.");
        return;
      }

      hideNotice();
      bypass = true;
      try {
        el.click();          // verify hone ke baad wahi button khud dabao
      } finally {
        bypass = false;
      }
    });
  }

  function onClick(e) {
    if (bypass) return;

    const path = (e.composedPath ? e.composedPath() : [e.target]).filter(
      n => n && n.nodeType === 1 && typeof n.matches === "function"
    );

    const checkout = path.find(n => n.matches(CHECKOUT_SEL));
    if (checkout) {
      guardCheckout(e, checkout);
      return;
    }

    if (path.some(n => n.matches(CART_CONTROL_SEL))) {
      markDirty();             // turant checkout lock
      queue(150);
      setTimeout(() => queue(0), 600);
      setTimeout(() => queue(0), 1500);
    }
  }

  /* ---------------- Init ---------------- */

  function init() {
    bindDrawer();

    let hostQueued = false;
    new MutationObserver(() => {
      if (hostQueued) return;
      hostQueued = true;
      requestAnimationFrame(() => {
        hostQueued = false;
        bindDrawer();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener("click", onClick, true);
    window.addEventListener("pageshow", () => queue(0));
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) queue(0);
    });

    // Backup: drawer khula ho to har 1.2s cart check (agar Shiprocket ki request miss ho jaye)
    setInterval(() => {
      if (document.hidden || pending || running) return;
      bindDrawer();
      if (drawerOpen()) queue(0);
    }, 1200);

    queue(0);
  }

  window.MagicGiftV16 = {
    refresh: () => {
      markDirty();
      queue(0);
    },
    inspect: async () => {
      await loadGift().catch(() => {});
      const c = await request("cart.js");
      return {
        eligibleSubtotal: paidSubtotal(c) / 100,
        eligible: paidSubtotal(c) >= CFG.threshold,
        giftInCart: c.items.some(isMarked),
        nextAction: next(c),
        pending,
        version,
        stableVersion,
        lastError,
        drawerFound: Boolean(getShadow()),
        items: c.items.map(i => ({
          title: i.title,
          qty: i.quantity,
          original: i.original_line_price / 100,
          final: i.final_line_price / 100,
          properties: i.properties
        }))
      };
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
